export default __webpack_public_path__ + "static/media/190629_190332_IMG_3055.bb1333c5.jpg";